export const es = {
  common: {
    actions: {
      cancel: 'Cancelar',
      create: 'Crear',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      void: 'Anular',
      add: 'Agregar',
      link: 'Vincular',
      back: 'Atras',
      discard: 'Descartar',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
      pending: 'Pendiente',
      voided: 'Anulado',
      open: 'Abierto',
      inProgress: 'En Progreso',
      draft: 'Borrador',
      closed: 'Cerrado',
      fulfilled: 'Cumplido',
      sent: 'Enviado',
      accepted: 'Aceptado',
      rejected: 'Rechazado',
      expired: 'Expirado',
      converted: 'Convertido',
      default: 'Predeterminado',
    },
    loading: {
      creating: 'Creando...',
      saving: 'Guardando...',
      linking: 'Vinculando...',
      adding: 'Agregando...',
      converting: 'Convirtiendo...',
      loadingMore: 'Cargando más...',
    },
    selected: 'seleccionados',
    errors: {
      loading: (entity: string, message: string) =>
        `Error al cargar ${entity}: ${message}`,
      notFound: (entity: string) => `${entity} no encontrado`,
      unknown: 'Ocurrio un error desconocido',
    },
    labels: {
      notes: 'Notas',
      noNotes: 'Sin notas',
      name: 'Nombre',
      status: 'Estado',
      created: 'Creado',
      item: 'Articulo',
      quantity: 'Cantidad',
      unit: 'Unidad',
      items: 'Articulos',
      description: 'Descripcion',
    },
    placeholders: {
      optionalNotes: 'Notas opcionales...',
      optionalDescription: 'Descripcion opcional...',
      searchAccount: 'Buscar una cuenta...',
      selectItem: 'Buscar un articulo...',
    },
    sections: {
      additionalInfo: 'Informacion Adicional',
    },
  },
  pricing: {
    variables: {
      list: {
        title: 'Variables',
        search: 'Buscar variables...',
        ariaLabel: 'Lista de variables',
        createButton: 'Crear Variable',
        empty: {
          title: 'No se encontraron variables',
          description:
            'Crea variables para usar en formulas de precios (ej., $precioCobre).',
        },
      },
      create: {
        title: 'Crear Variable',
        sections: {
          details: 'Detalles de la Variable',
        },
        fields: {
          name: 'Nombre',
          description: 'Descripcion',
          value: 'Valor',
        },
        placeholders: {
          name: 'ej., precioCobre',
          description: 'Descripcion opcional...',
          value: '0.00',
        },
        submitButton: 'Crear Variable',
      },
      edit: {
        title: 'Editar Variable',
        submitButton: 'Guardar Cambios',
      },
      table: {
        columns: {
          name: 'Nombre',
          description: 'Descripcion',
          value: 'Valor',
          updatedBy: 'Ultima Actualizacion Por',
          created: 'Creado',
        },
      },
      toast: {
        created: 'Variable creada exitosamente',
        updated: 'Variable actualizada exitosamente',
        deleted: 'Variable eliminada exitosamente',
        createError: (error: string) => `Error al crear la variable: ${error}`,
        updateError: (error: string) =>
          `Error al actualizar la variable: ${error}`,
        deleteError: (error: string) =>
          `Error al eliminar la variable: ${error}`,
      },
      validation: {
        nameRequired: 'El nombre es requerido',
        valueRequired: 'El valor es requerido',
        nameFormat:
          'El nombre debe comenzar con una letra o digito y contener solo letras, numeros y guiones bajos',
      },
      history: {
        title: 'Historial de Variable',
        empty: 'No hay historial registrado para esta variable.',
        events: {
          created: 'Variable Creada',
          updated: 'Variable Actualizada',
          deleted: 'Variable Eliminada',
        },
        initialValue: 'Valor:',
      },
      deleteConfirm: {
        message: (name: string) =>
          `¿Estas seguro de que quieres eliminar la variable "${name}"? Esto puede afectar las formulas de precios que la referencian.`,
      },
    },
    counterpartyGroups: {
      list: {
        title: 'Grupos de Contrapartes',
        search: 'Buscar grupos de contrapartes...',
        ariaLabel: 'Lista de grupos de contrapartes',
        allOperationTypes: 'Todos los Tipos',
        createButton: 'Crear Grupo',
        empty: {
          title: 'No se encontraron grupos de contrapartes',
          description:
            'Crea grupos de contrapartes para organizar cuentas con precios personalizados.',
        },
      },
      detail: {
        title: 'Grupo de Contraparte',
        backButton: 'Volver a Grupos de Contrapartes',
        tabs: {
          members: 'Miembros',
        },
        memberCount: (count: number) =>
          `${count} ${count === 1 ? 'miembro' : 'miembros'}`,
        subtitle: {
          created: 'Creado',
          lastUpdatedBy: 'Última Actualización Por',
          on: 'el',
        },
        members: {
          empty: {
            title: 'Sin miembros',
            description:
              'Agrega cuentas a este grupo de contrapartes para aplicar precios personalizados.',
          },
          addButton: 'Agregar Cuentas',
          removeButton: 'Eliminar',
          removeConfirm: 'Eliminar esta cuenta del grupo?',
          accountNameHeader: 'Cuenta',
          accountTypeHeader: 'Tipo',
          addedByHeader: 'Agregado por',
          addedDateHeader: 'Agregado',
          searchPlaceholder: 'Buscar cuentas...',
          searchAriaLabel: 'Buscar cuentas para agregar',
          addDialogTitle: 'Agregar Cuentas',
          addDialogSubmit: 'Agregar Seleccionadas',
          noAccountsFound: 'No se encontraron cuentas',
          alreadyMember: 'Ya es miembro',
        },
      },
      create: {
        title: 'Crear Grupo de Contraparte',
        sections: {
          groupDetails: 'Detalles del Grupo',
        },
        fields: {
          name: 'Nombre',
          operationType: 'Tipo de Operacion',
        },
        placeholders: {
          name: 'ej., Proveedores Premium',
        },
        submitButton: 'Crear Grupo',
      },
      edit: {
        title: 'Editar Grupo de Contraparte',
        submitButton: 'Guardar Cambios',
      },
      table: {
        columns: {
          name: 'Nombre',
          operationType: 'Tipo de Operacion',
          memberCount: 'Cuentas',
          updatedAt: 'Actualizado',
          created: 'Creado',
        },
      },
      toolbar: {
        selected: 'seleccionados',
        delete: (count: number) =>
          `Eliminar ${count} ${count === 1 ? 'grupo' : 'grupos'}`,
      },
      deleteConfirm: {
        message: (name: string) =>
          `¿Está seguro de que desea eliminar "${name}"? Esto eliminará todas las asociaciones de miembros.`,
      },
      toast: {
        created: 'Grupo de contraparte creado exitosamente',
        updated: 'Grupo de contraparte actualizado exitosamente',
        deleted: 'Grupo de contraparte eliminado exitosamente',
        bulkDeleted: (count: number) =>
          `${count} ${count === 1 ? 'grupo de contraparte eliminado' : 'grupos de contrapartes eliminados'}`,
        accountsAdded: 'Cuentas agregadas exitosamente',
        accountsRemoved: 'Cuentas eliminadas exitosamente',
        addAccountsError: (error: string) =>
          `Error al agregar cuentas: ${error}`,
        createError: (error: string) =>
          `Error al crear el grupo de contraparte: ${error}`,
        updateError: (error: string) =>
          `Error al actualizar el grupo de contraparte: ${error}`,
        deleteError: (error: string) =>
          `Error al eliminar el grupo de contraparte: ${error}`,
      },
      validation: {
        nameRequired: 'El nombre es requerido',
      },
    },
    defaultPriceList: {
      title: 'Lista de Precios Predeterminada',
      selectors: {
        facility: 'Instalacion',
        operationType: 'Tipo de Operacion',
        currency: 'Moneda',
        selectFacility: 'Selecciona una instalacion...',
        selectOperationType: 'Selecciona tipo de operacion...',
        currencyPlaceholder: 'USD',
      },
      notes: {
        label: 'Notas',
        placeholder: 'Agregar notas...',
        saved: 'Notas guardadas',
      },
      productPricings: {
        title: 'Precios de Productos',
        addButton: 'Agregar Precio de Producto',
        empty: {
          title: 'Sin precios de productos',
          description:
            'Agrega precios de productos para definir precios predeterminados para esta instalacion y tipo de operacion.',
        },
      },
      effectiveDate: {
        label: 'Fecha Efectiva de Niveles',
        discard: 'Descartar',
      },
      toast: {
        notesSaved: 'Notas actualizadas exitosamente',
        effectiveDateSaved:
          'Fecha efectiva actualizada para todos los precios de producto',
        productPricingAdded: 'Precio de producto agregado',
        productPricingUpdated: 'Precio de producto actualizado',
        productPricingDeleted: 'Precio de producto eliminado',
        error: (error: string) => `La operacion fallo: ${error}`,
      },
      prompt:
        'Selecciona una instalacion, tipo de operacion y moneda para ver o crear la lista de precios predeterminada.',
    },
    customPriceLists: {
      entityName: 'listas de precios personalizadas',
      list: {
        title: 'Listas de Precios Personalizadas',
        search: 'Buscar listas de precios personalizadas...',
        ariaLabel: 'Listas de precios personalizadas',
        createButton: 'Crear Lista de Precios',
        empty: {
          title: 'No se encontraron listas de precios personalizadas',
          description:
            'Crea un borrador de lista de precios personalizada para grupos de contrapartes especificos.',
          emptyTab: (tab: string) =>
            `No hay listas de precios ${tab.toLowerCase()}`,
        },
        statusTabs: {
          all: 'Todos',
          active: 'Activos',
          expired: 'Expirados',
          archived: 'Archivados',
          draft: 'Borradores',
        },
      },
      detail: {
        title: 'Lista de Precios Personalizada',
        backButton: 'Volver a Listas de Precios Personalizadas',
        tabs: {
          pricings: 'Precios de Productos',
        },
        pricingCount: (count: number) =>
          `${count} ${count === 1 ? 'precio' : 'precios'}`,
        subtitle: {
          created: 'Creado',
          counterpartyGroup: 'Grupo de Contraparte',
          startsOn: 'Inicia el',
          lastUpdatedBy: 'Última Actualización Por',
          on: 'el',
        },
        actions: {
          publish: 'Publicar',
          archive: 'Archivar',
          unarchive: 'Desarchivar',
          delete: 'Eliminar',
          edit: 'Editar Detalles',
          copyFrom: 'Copiar de Lista',
          importFrom: 'Extraer de otra lista de precios',
          actionsMenu: 'Acciones',
          confirmDelete: {
            title: 'Eliminar Lista de Precios',
            description:
              'Esta seguro de que desea eliminar esta lista de precios? Esta accion no se puede deshacer.',
            confirm: 'Eliminar',
          },
          duplicate: 'Duplicar',
          downloadPdf: 'Descargar PDF',
          sendEmail: 'Enviar por Email',
          viewHistory: 'Ver Historial',
        },
        effectiveDate: {
          label: 'Fecha Efectiva de Niveles',
          discard: 'Descartar',
        },
        toast: {
          effectiveDateSaved: 'Fecha efectiva actualizada',
          updated: 'Lista de precios actualizada',
          updateError: (error: string) =>
            `Error al actualizar lista de precios: ${error}`,
        },
        pricings: {
          empty: {
            title: 'Sin precios de productos',
            description:
              'Agrega precios de productos a esta lista de precios personalizada.',
          },
          addButton: 'Agregar Precio de Producto',
        },
      },
      create: {
        title: 'Crear Lista de Precios',
        draftNote:
          'La lista de precios se guardara como borrador. Despues de agregar materiales y precios, se puede publicar.',
        sections: {
          details: 'Detalles de la Lista de Precios',
          dates: 'Periodo de Vigencia',
        },
        fields: {
          name: 'Nombre',
          operationType: 'Tipo de Operacion',
          pricingMode: 'Modo de Precios',
          pricingModeStandard: 'Estandar',
          pricingModeCRV: 'CRV',
          pricingModeStandardDescription:
            'Precios completos con min, objetivo y max por nivel',
          pricingModeCRVDescription:
            'Precios CRV con solo valor de chatarra (sin min/objetivo/max)',
          currency: 'Moneda',
          counterpartyGroup: 'Grupo de Contraparte',
          facility: 'Instalacion',
          startDate: 'Fecha de Inicio',
          endDate: 'Fecha de Fin',
          notes: 'Notas',
        },
        placeholders: {
          name: 'ej., Q1 2026 Proveedores Premium',
          currency: 'USD',
          counterpartyGroup: 'Seleccionar grupo de contraparte...',
          facility: 'Seleccionar instalacion...',
          notes: 'Notas opcionales...',
        },
        submitButton: 'Crear Lista de Precios',
      },
      status: {
        draft: 'Borrador',
        active: 'Activo',
        expired: 'Expirado',
        archived: 'Archivado',
      },
      table: {
        columns: {
          name: 'Nombre',
          operationType: 'Tipo de Operacion',
          status: 'Estado',
          pricingMode: 'Modo de Precios',
          currency: 'Moneda',
          startDate: 'Fecha de Inicio',
          endDate: 'Fecha de Fin',
          created: 'Creado',
          updated: 'Actualizado',
        },
      },
      copyFrom: {
        sourceType: 'Tipo de Fuente',
        defaultPriceList: 'Lista de Precios Predeterminada',
        customPriceList: 'Lista de Precios Personalizada',
        selectSource: 'Seleccionar Fuente',
        sourcePriceList: 'Lista de Precios Fuente',
        copyButton: 'Copiar Precios',
      },
      importFrom: {
        selectSource: 'Seleccionar Fuente',
        sourcePriceList: 'Lista de Precios Fuente',
        selectItems: 'Seleccionar Elementos a Importar',
        selectAll: 'Seleccionar Todos',
        importButton: 'Importar Seleccionados',
      },
      duplicate: {
        copyFromField: 'Copiar precios de',
        placeholder: 'Seleccionar una lista de precios para copiar...',
      },
      toast: {
        created: 'Borrador de lista de precios creado',
        updated: 'Lista de precios actualizada',
        published: 'Lista de precios publicada',
        archived: 'Lista de precios archivada',
        unarchived: 'Lista de precios desarchivada',
        deleted: 'Lista de precios eliminada',
        duplicated: 'Lista de precios duplicada',
        copiedFrom: 'Precios copiados exitosamente',
        importedFrom: 'Precios importados exitosamente',
        createError: (error: string) =>
          `Error al crear la lista de precios: ${error}`,
        publishError: (error: string) =>
          `Error al publicar la lista de precios: ${error}`,
        archiveError: (error: string) =>
          `Error al archivar la lista de precios: ${error}`,
        deleteError: (error: string) =>
          `Error al eliminar la lista de precios: ${error}`,
        duplicateError: (error: string) =>
          `Error al duplicar la lista de precios: ${error}`,
        copyFromError: (error: string) =>
          `Error al copiar los precios: ${error}`,
        importFromError: (error: string) =>
          `Error al importar los precios: ${error}`,
        pdfGenerated: 'PDF generado exitosamente',
        pdfError: (error: string) => `Error al generar PDF: ${error}`,
        emailSent: 'Email enviado exitosamente',
        emailError: (error: string) => `Error al enviar email: ${error}`,
      },
      history: {
        title: 'Historial de Lista de Precios',
        empty: 'No se encontraron entradas de historial.',
      },
      email: {
        title: 'Enviar Lista de Precios por Email',
        recipients: 'Destinatarios',
        addRecipient: 'Ingrese direccion de email...',
        subject: 'Asunto',
        sendButton: 'Enviar Email',
      },
      validation: {
        nameRequired: 'El nombre es requerido',
        counterpartyGroupRequired: 'El grupo de contraparte es requerido',
        facilityRequired: 'La instalacion es requerida',
      },
    },
    itemPricings: {
      addButton: 'Agregar Precio de Producto',
      table: {
        columns: {
          product: 'Material',
          pricingUnit: 'Unidad de Precio',
          minWeight: 'Peso Min',
          maxAmount: 'Peso Max',
          targetPrice: 'Precio Objetivo',
          minPrice: 'Precio Min',
          maxPrice: 'Precio Max',
          scrapValue: 'Valor Desecho',
        },
        tieredPricing: '(Precio Escalonado)',
        selectMaterial: 'Seleccionar material...',
        addTier: 'Agregar Nivel',
        copyItem: 'Copiar',
        deleteItem: 'Eliminar',
      },
      deleteConfirm:
        'Esta seguro de que desea eliminar este precio de producto? Esta accion no se puede deshacer.',
      toast: {
        added: 'Precio de producto agregado',
        updated: 'Precio de producto actualizado',
        deleted: 'Precio de producto eliminado',
        tierAdded: 'Nivel agregado exitosamente',
        error: (error: string) => `La operacion fallo: ${error}`,
      },
    },
    formulaUI: {
      variablesPanel: {
        title: 'Variables',
        empty:
          'No hay variables definidas. Crea variables para usar en formulas de precios.',
        manageVariables: 'Administrar Variables',
      },
      variablesButton: 'Variables',
    },
    groups: {
      ungrouped: 'Sin grupo',
    },
    search: {
      placeholder: 'Buscar materiales...',
    },
    bulk: {
      selectAll: 'Seleccionar Todo',
    },
    asOf: {
      label: 'Ver a fecha de',
      timeLabel: 'Hora',
      clearButton: 'Mostrar precios actuales',
      historicalIndicator: 'Viendo precios históricos',
      futureIndicator: 'Viendo precios programados',
    },
    saveToolbar: {
      unsavedChanges: (count: number) =>
        `${count} cambio${count !== 1 ? 's' : ''} sin guardar`,
      reviewMessage:
        'Se han realizado cambios. Para activar los cambios proceda con la revisión.',
      reviewAndSave: 'Revisar y Guardar',
      effectiveDate: 'Fecha efectiva',
      effectiveTime: 'Hora efectiva',
      save: 'Guardar cambios',
      activate: 'Activar Cambios',
      revert: 'Revertir Cambios',
      discard: 'Descartar',
      confirmRevert: {
        title: 'Revertir Cambios',
        description:
          'Los cambios se revertirán después de confirmar esta acción. ¿Desea continuar?',
        confirm: 'Revertir todo',
        keep: 'No, mantener',
      },
      saved: 'Cambios guardados exitosamente',
      minExceedsTarget:
        'El precio mínimo no puede exceder el precio objetivo. Revise los valores.',
      maxBelowTarget:
        'El precio máximo no puede ser menor al precio objetivo. Revise los valores.',
      targetPriceRequired:
        'El precio objetivo es obligatorio para todos los niveles.',
      lastTierMustBeUnbounded:
        'El último nivel de cada material debe tener peso máximo ilimitado.',
      duplicateItem:
        'Combinación de material y unidad duplicada. Cada material solo puede aparecer una vez por unidad.',
      incompleteNewRow:
        'Seleccione un material y una unidad de precio para todas las filas nuevas.',
    },
    variableSaveToolbar: {
      reviewMessage: 'cambios de variables pendientes por revisar',
      reviewAndSave: 'Revisar y Guardar',
      activate: 'Activar',
      revert: 'Revertir',
      effectiveTime: 'Hora efectiva',
      confirmRevert: {
        description:
          '¿Está seguro de que desea descartar todos los cambios pendientes?',
        keep: 'Mantener Cambios',
        confirm: 'Descartar Todo',
      },
      review: {
        variable: 'Variable',
        oldValue: 'Actual',
        newValue: 'Nuevo Valor',
      },
    },
    validation: {
      title: 'Problemas de Validacion',
      error: (count: number) => `${count} ${count === 1 ? 'error' : 'errores'}`,
      warning: (count: number) =>
        `${count} ${count === 1 ? 'advertencia' : 'advertencias'}`,
      tier: (n: number) => `Nivel ${n}`,
    },
  },
};
